import { FC } from 'react';
import RelatedGrid from '@components/relatedGrid/RelatedGrid';
import { SeeAll } from '@components/seeAll';
import { Title } from '@components/title';
import { IRelatedRecipe } from '@shared/models/relatedRecipe.model';
import { ModuleType } from '@shared/types/module.type';
import { analytics } from '@shared/utils/segment.utils';
interface Props {
  data: IRelatedRecipe[];
}
const RelatedRecipe: FC<Props> = ({
  data
}: Props) => {
  return <RelatedGrid cardType={ModuleType.Recipe} title={<Title text={'เมนูคัดสรรเพื่อคุณ'} extra={<SeeAll url="/search" onClick={() => {
    analytics.track('Related Recipe See All Click', {
      event: 'Related Recipe See All Click'
    });
  }} />} />} dataList={data} desktopColumn={4} mobileColumn={2} eventSection="Related Recipe" />;
};
export default RelatedRecipe;